
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/groupPurchases/payment/creditCard",
      function () {
        return require("private-next-pages/groupPurchases/payment/creditCard.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/groupPurchases/payment/creditCard"])
      });
    }
  